const CONFIG_KEY = 'trackLayerConfig';
let _config = null;

const getConfig = (initialOptions = {}) => {
  if (!_config) {
    const windowConfig = window[CONFIG_KEY] || {};

    _config = {
      enabled: true,
      environment: 'prod', // dev/prod
      apiUrl: null,
      customer: null,
      ...windowConfig,
      ...initialOptions,
      consent: {
        enabled: false,
        cmpFunction: '__cmp',
        ...(windowConfig.consent || {}),
        ...(initialOptions.consent || {}),
      },
      cookies: {},
    };
  }
  return _config;
};

const setConfig = (newConfig) => {
  _config = newConfig;
};

const mergeConfig = (partialConfig) => {
  if (!_config) getConfig();

  _config = {
    ..._config,
    ...partialConfig,
    consent: {
      ..._config.consent,
      ...(partialConfig.consent || {}),
    },
  };
};

const config = {
  getConfig,
  setConfig,
  mergeConfig,
};

export default config;